module.exports = __webpack_public_path__ + "images/category_lp/pc/media5_2940b42aa3fee72e55dd94e4503120cd.jpg";